<template>
  <div class="kanban-card" :class="priorityClass">
    <div class="left">
      <div class="title">
        <a :href="`/tickets/${task.slug}`">{{task.summary}}</a>

        <span class="copy-icon"><i title="Copy task URL to clipboard as markdown, Ctrl/Cmd click to include title" @click="copy" :class="'fa fa-' + (textCopied ? 'check' : 'link')"></i></span>

      </div>
      <small class="project">
        <span class="box" :style="{backgroundColor: task.project.color}"></span>
        <a :href="`/projects/view/${task.project.id}`">
          {{task.project.title}}
          <span v-if="task.account"><br/>{{task.account.name}}</span>
        </a>
      </small>
    </div>
    <a v-if="canAssign" href="#" class="assignee" @click.prevent="showDropdown = !showDropdown">
      <img v-if="task.assignee" :src="task.assignee.iconUrl" :title="`Assigned to ${this.task.assignee.fullname}`" />
      <img v-else src="https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y" title="Unassigned" />
      <div class="dropdown-menu dropdown-menu-right" v-if="showDropdown" style="display: block" v-on-clickaway="clickAway">
        <h6 class="dropdown-header">Assign to</h6>
        <a v-for="user in availableWorkers" class="dropdown-item" href="#" @click.prevent="assign(user)" :class="{active: task.assignee ? task.assignee.id === user.id : false }">{{user.fullname}}</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" href="#" @click.prevent="assign(null)">Unassign</a>
      </div>
    </a>
    <div v-else class="assignee">
      <img v-if="task.assignee" :src="task.assignee.iconUrl" :title="`Assigned to ${this.task.assignee.fullname}`" />
      <img v-else src="https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y" title="Unassigned" />
    </div>
    <div class="arrows">
      <a href="#" @click.prevent="canShiftLeft && updateStatus(0)" :class="canShiftLeft ? '' : 'disabled'">
        <i class="fa fa-angle-double-left"></i>
      </a>
      <a href="#" @click.prevent="canShiftLeft && updateStatus(task.status - 1)" :class="canShiftLeft ? '' : 'disabled'">
        <i class="fa fa-angle-left"></i>
      </a>
      <a href="#" @click.prevent="canShiftRight && updateStatus(task.status + 1)" :class="canShiftRight ? '' : 'disabled'">
        <i class="fa fa-angle-right"></i>
      </a>
      <a href="#" @click.prevent="canShiftRight && updateStatus(3)" :class="canShiftRight ? '' : 'disabled'">
        <i class="fa fa-angle-double-right"></i>
      </a>
    </div>
  </div>
</template>

<script>
 import eventBus from './kanban/event-bus';
 import { directive as onClickaway } from 'vue-clickaway';
 import {isCtrlOrCmd, copyText} from '../utils';

 export default {
   props: [
     'task',
     'canAssign',
     'availableWorkers',
   ],

   directives: {
     onClickaway
   },

   data() {
     return {
       showDropdown: false,
       textCopied: false,
     }
   },

   computed: {
     priorityClass() {
       const priorities = ['low', 'normal', 'high'];
       return 'priority-' + priorities[this.task.priority];
     },
     canShiftLeft() {
       return this.task.status > 0;
     },
     canShiftRight() {
       return this.task.status < 3;
     },
   },
   methods: {
     updateStatus(status) {
       eventBus.$emit('update-task-status', {
         task: this.task,
         status
       });
     },
     assign(user) {
       eventBus.$emit('assign-task', {
         task: this.task,
         assignee: user,
       });
     },
     clickAway() {
       if (this.showDropdown) {
         this.showDropdown = false;
       }
     },
     copy(e) {
       const url = `${window.location.origin}/tickets/${this.task.slug}`;
       const markdown = `[${this.task.slug}${isCtrlOrCmd(e) ? (' ' + this.task.title) : ''}](${url})`;

       copyText(markdown);
       this.textCopied = true;
       setTimeout(() => {
         this.textCopied = false;
       }, 2000);
     }
   }
 }
</script>



// WEBPACK FOOTER //
// assets/js/components/KanbanCard.vue